import { enableProdMode } from '@angular/core';
import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';

import { AppModule } from './app/app.module';
import { environment } from './environments/environment';
import { datadogRum } from '@datadog/browser-rum';

if (environment.production) {
  enableProdMode();
}
 
datadogRum.init({
    applicationId: '3f8a9521-d8b8-4874-b104-07b1c65987e2',
    clientToken: 'pubb7b014f3e4b8baacf92261d45fc14280',
    // `site` refers to the Datadog site parameter of your organization
    // see https://docs.datadoghq.com/getting_started/site/
    site: 'datadoghq.eu',
    service: 'opcosquare',
    env: 'Unknown',
    // Specify a version number to identify the deployed version of your application in Datadog
    // version: '1.0.0', 
    sessionSampleRate: 100,
    sessionReplaySampleRate: 0,
    trackUserInteractions: true,
    trackResources: true,
    trackLongTasks: true,
    defaultPrivacyLevel: 'mask-user-input',
    allowFallbackToLocalStorage: true,
    allowedTracingUrls: [environment.url.api],
    traceSampleRate: 20,
    traceContextInjection: 'sampled',
});

platformBrowserDynamic()
  .bootstrapModule(AppModule)
  .catch((err) => console.error(err));
